/* ================================
   WISHLIST – Retro Skipakken (fixed)
   ================================ */
(() => {
  // ---- Singleton guard: prevent double init ----
  if (window.__RETRO_WISHLIST_LOADED__) {
    console.debug('[Wishlist] already loaded – skipping duplicate init');
    return;
  }
  window.__RETRO_WISHLIST_LOADED__ = true;

  /* ---------- Config ---------- */
  const LS_KEY = 'wishlist';
  const SELECTORS = {
    container: '#wishlist-container',
    template: '#wishlist-card-template',
    count: '#WishlistCount',
    addAllBtn: '#add-all-to-cart',
  };
  const IMAGE_SIZES = {
    default: '600x800_crop_center',
    srcset: [
      '300x400_crop_center 300w',
      '450x600_crop_center 450w',
      '600x800_crop_center 600w',
    ],
  };
  const EMPTY_STATE_HTML =
    '<p style="text-align:center;color:#666;padding:2rem;">Je hebt nog geen favorieten toegevoegd.</p>';

  /* ---------- Money Fallback ---------- */
  if (typeof window.Shopify === 'undefined') window.Shopify = {};
  if (typeof Shopify.formatMoney !== 'function') {
    Shopify.formatMoney = (cents) =>
      new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })
        .format((Number(cents) || 0) / 100);
  }

  /* ---------- Utilities (no new globals) ---------- */
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const debounce =
    (typeof window !== 'undefined' && window.debounce) ||
    function (fn, wait = 300) {
      let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(null, args), wait); };
    };

  function withProtocol(url) {
    if (!url) return url;
    if (url.startsWith('//')) return 'https:' + url;
    if (url.startsWith('/')) return window.location.origin + url;
    return url;
  }

  function addCdnSize(url, size = IMAGE_SIZES.default) {
    if (!url) return url;
    const full = withProtocol(url);
    const [path, query] = full.split('?');
    const dot = path.lastIndexOf('.');
    if (dot === -1) return full;
    const base = path.slice(0, dot);
    const ext = path.slice(dot);
    const alreadySized = /_(\d+)x(\d+)(_crop(_(center|top|bottom|left|right))?)?$/.test(base);
    const sized = alreadySized ? base + ext : `${base}_${size}${ext}`;
    return query ? `${sized}?${query}` : sized;
  }

  function pickProductImage(product) {
    if (product?.featured_image?.src) return product.featured_image.src;
    if (typeof product?.featured_image === 'string') return product.featured_image;
    if (Array.isArray(product?.images) && product.images.length) return product.images[0];
    if (product?.variants?.[0]?.featured_image?.src) return product.variants[0].featured_image.src;
    return null;
  }

  /* ---------- Sections helper ---------- */
  function getCartSections() {
    const common = [
      'cart-notification-product',
      'cart-notification-button',
      'cart-icon-bubble',
      'cart-notification-total',
    ];
    return Array.isArray(window.THEME_CART_SECTIONS) ? window.THEME_CART_SECTIONS : common;
  }

  /* --- Added-state opslag (session) --- */
  const ADDED_SS_KEY = 'wishlist_added_variants';
  function getAddedSet() {
    try {
      const arr = JSON.parse(sessionStorage.getItem(ADDED_SS_KEY) || '[]');
      return new Set(Array.isArray(arr) ? arr : []);
    } catch { return new Set(); }
  }
  function saveAddedSet(set) {
    sessionStorage.setItem(ADDED_SS_KEY, JSON.stringify([...set]));
  }

  // Helper: visuele tekst in icon-only knop bijwerken
  function setButtonLabel(button, label) {
    if (!button) return;
    const textTarget = button.querySelector('[data-button-text]');
    if (textTarget) {
      textTarget.textContent = label;
    } else {
      button.textContent = label;
    }
    button.setAttribute('aria-label', label);
  }

  function resetButtonLabel(button) {
    setButtonLabel(button, button?.dataset?.defaultLabel || 'In winkelwagen');
  }

  // ✔️ Toon "Toegevoegd!" notificatie boven de knop (zoals collection page)
  function showAddedNotification(button) {
    if (!button) return;

    // Verwijder bestaande notificatie als die er is
    const existing = button.closest('.card-wrapper')?.querySelector('.quick-add-notification');
    if (existing) existing.remove();

    // Maak notificatie element
    const notification = document.createElement('div');
    notification.className = 'quick-add-notification';
    notification.textContent = 'Toegevoegd!';
    notification.style.cssText = `
      position: absolute;
      bottom: 5.5rem;
      right: 1.6rem;
      background: #49A592;
      color: white;
      padding: 6px 12px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 600;
      white-space: nowrap;
      z-index: 100;
      animation: fadeInOut 2s ease forwards;
      pointer-events: none;
    `;

    // Voeg keyframes toe als die nog niet bestaan
    if (!document.querySelector('#wishlist-notification-styles')) {
      const style = document.createElement('style');
      style.id = 'wishlist-notification-styles';
      style.textContent = `
        @keyframes fadeInOut {
          0% { opacity: 0; transform: translateY(5px); }
          15% { opacity: 1; transform: translateY(0); }
          85% { opacity: 1; transform: translateY(0); }
          100% { opacity: 0; transform: translateY(-5px); }
        }
      `;
      document.head.appendChild(style);
    }

    // Voeg notificatie toe aan card-wrapper
    const cardWrapper = button.closest('.card-wrapper');
    if (cardWrapper) {
      cardWrapper.appendChild(notification);
      setTimeout(() => notification.remove(), 2000);
    }
  }

  // ✔️ Knop naar "Toegevoegd" state (voor cart sync)
  function applyAddedState(button) {
    if (!button) return;
    button.classList.add('is-added');
    button.setAttribute('aria-pressed', 'true');
  }

  // ⬅️ NIEUW: knop terug naar normale state
  function clearAddedState(button) {
    if (!button) return;
    button.classList.remove('is-added');
    button.setAttribute('aria-pressed', 'false');
  }

  // ⬅️ Optionele mini-animatie bij succes
  function pulseAdded(button) {
    if (!button) return;
    button.classList.add('added-pulse');
    setTimeout(() => button.classList.remove('added-pulse'), 500);
  }

  /* ---------- Wishlist Storage ---------- */
  function getWishlist() {
    try {
      const arr = JSON.parse(localStorage.getItem(LS_KEY) || '[]');
      const unique = Array.from(new Set(Array.isArray(arr) ? arr : []));
      if (unique.length !== (arr?.length || 0)) {
        localStorage.setItem(LS_KEY, JSON.stringify(unique));
      }
      return unique;
    } catch { return []; }
  }

  function setWishlist(list) {
    const unique = Array.from(new Set(list || []));
    localStorage.setItem(LS_KEY, JSON.stringify(unique));
    updateWishlistCount();
    highlightWishlistIcons();
    document.dispatchEvent(new Event('wishlist:changed'));
  }

  function addToWishlist(handle) {
    const list = getWishlist();
    if (!list.includes(handle)) setWishlist([...list, handle]);
  }
  function removeFromWishlist(handle) {
    setWishlist(getWishlist().filter((h) => h !== handle));
  }

  // Expose helpers voor templates/buttons
  window.addToWishlist = addToWishlist;
  window.removeFromWishlist = removeFromWishlist;

  function highlightWishlistIcons() {
    const wishlist = getWishlist();
    const buttons = document.querySelectorAll('.wishlist-toggle[data-handle]');
    buttons.forEach((button) => {
      const handle = button.dataset.handle;
      button.classList.toggle('active', wishlist.includes(handle));
    });
  }

  /* ---------- Teller ---------- */
  function updateWishlistCount() {
    const el = $(SELECTORS.count);
    if (!el) return;
    el.textContent = getWishlist().length;
    el.classList.add('highlight');
    setTimeout(() => el.classList.remove('highlight'), 250);
  }

  /* ---------- Data Fetch (met cache) ---------- */
  const productCache = new Map();
  async function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    const url = `/products/${encodeURIComponent(handle)}.js`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Product ${handle} niet gevonden`);
    const data = await res.json();
    productCache.set(handle, data);
    return data;
  }

  /* ---------- Rendering ---------- */
  let rendering = false;
  async function renderWishlist() {
    if (rendering) return;
    rendering = true;

    const container = $(SELECTORS.container);
    if (!container) {
      console.warn('[Wishlist] #wishlist-container niet gevonden');
      rendering = false;
      return;
    }

    const handles = Array.from(new Set(getWishlist()));
    container.setAttribute('aria-busy', 'true');
    container.innerHTML = '';

    if (!handles.length) {
      container.innerHTML = EMPTY_STATE_HTML;
      rendering = false;
      container.removeAttribute('aria-busy');
      return;
    }

    const seen = new Set();
    await Promise.all(
      handles.map(async (handle) => {
        if (seen.has(handle)) return;
        seen.add(handle);
        const node = await buildWishlistCard(handle).catch((err) => {
          console.warn(`⚠️ Kon kaart niet bouwen voor ${handle}:`, err);
          return null;
        });
        if (node) container.appendChild(node);
      })
    );

    rendering = false;
    container.removeAttribute('aria-busy');
  }

  async function buildWishlistCard(handle) {
    const product = await fetchProduct(handle);

    const tpl = $(SELECTORS.template);
    if (!tpl) throw new Error('Template #wishlist-card-template ontbreekt');

    const frag = tpl.content.cloneNode(true);
    const root = frag.querySelector('.card-wrapper') || frag.firstElementChild;
    if (root) root.classList.add('wishlist-card');

    const wishlistBtn = frag.querySelector('.wishlist-toggle');
    if (wishlistBtn) {
      wishlistBtn.dataset.handle = handle;
      wishlistBtn.classList.add('active');
      wishlistBtn.setAttribute('aria-pressed', 'true');
      wishlistBtn.addEventListener('click', (event) => {
        event.preventDefault();
        removeFromWishlist(handle);
        root?.remove();
      });
    }

    /* Links & titels */
    const productUrl = `/products/${encodeURIComponent(handle)}`;
    const mediaLink = frag.querySelector('.card__media a');
    const titleLink = frag.querySelector('.full-unstyled-link');
    if (mediaLink) mediaLink.href = productUrl;
    if (titleLink) {
      titleLink.href = productUrl;
      titleLink.textContent = product.title || 'Product';
    }

    /* Prijs */
    const priceEl = frag.querySelector('.price');
    if (priceEl) {
      const priceCents = product.price ?? product.variants?.[0]?.price ?? 0;
      priceEl.textContent = Shopify.formatMoney(priceCents);
    }

    /* Afbeelding */
    const img = frag.querySelector('[data-image]');
    const raw = pickProductImage(product);
    if (img) {
      if (raw) {
        img.src = addCdnSize(raw, IMAGE_SIZES.default);
        img.srcset = IMAGE_SIZES.srcset
          .map((s) => {
            const [size, w] = s.split(' ');
            return `${addCdnSize(raw, size)} ${w}`;
          })
          .join(', ');
        img.sizes =
          '(max-width: 480px) 100vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw';
        img.alt = product.title || 'Productafbeelding';
        img.loading = 'lazy';
        img.decoding = 'async';
      } else {
        img.src = '{{ "placeholder-image.svg" | asset_url }}';
        img.alt = 'Geen afbeelding beschikbaar';
      }
    }

    /* Quick add */
    const addBtn = frag.querySelector('.quick-add__submit');
    const firstVariantId = product?.variants?.[0]?.id;
    const isAvailable = Boolean(firstVariantId && product?.available);

    /* Sold-out badge */
    const soldOutBadge = frag.querySelector('[data-sold-out-badge]');
    if (soldOutBadge) {
      if (!isAvailable) {
        soldOutBadge.style.display = '';
      }
    }

    if (addBtn) {
      const quickAddWrapper = addBtn.closest('.quick-add');
      if (!isAvailable) {
        quickAddWrapper?.remove();
      } else {
        addBtn.setAttribute('data-variant-id', String(firstVariantId));
        resetButtonLabel(addBtn);
        const addedSet = getAddedSet();
        if (addedSet.has(String(firstVariantId))) {
          applyAddedState(addBtn);
        } else {
          addBtn.addEventListener('click', () => handleAddToCart(addBtn, firstVariantId));
        }
      }
    }

    return frag;
  }

  /* ---------- Cart UI refresh (counter/drawer) ---------- */
  async function refreshCartUI() {
    try {
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist' });
      }
    } catch (e) {}

    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) {}

    try {
      const res = await fetch('/?sections=cart-icon-bubble', { credentials: 'same-origin' });
      if (res.ok) {
        const json = await res.json();
        const html = json['cart-icon-bubble'];
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const fresh = tmp.querySelector('#cart-icon-bubble');
        const current = document.querySelector('#cart-icon-bubble');
        if (fresh && current) current.replaceWith(fresh);
      }
    } catch (e) {}
  }

  /* ---------- Cart Notification ---------- */
  async function showCartNotificationFromParsedState(parsedState) {
    try {
      const notifier = document.querySelector('cart-notification');
      const notifRoot = document.getElementById('cart-notification');
      if (!notifier || !notifRoot || typeof notifier.renderContents !== 'function') {
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist', parsedState });
          if (window.PUB_SUB_EVENTS?.cartOpen)
            publish(PUB_SUB_EVENTS.cartOpen, { source: 'wishlist' });
        }
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:open', { detail: { source: 'wishlist' } })
        );
        return;
      }
      notifier.renderContents(parsedState);
      notifRoot.removeAttribute('hidden');
      notifier.open?.();
      notifRoot.focus?.();
    } catch (e) {}
  }

  /* ---------- Cart Actions ---------- */
  async function handleAddToCart(button, variantId) {
    if (!variantId) return;
    if (button.disabled) return;
    button.disabled = true;

    try {
      const sections = getCartSections();

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections,
          sections_url: window.location.pathname,
        }),
      });
      if (!res.ok) throw new Error('Toevoegen mislukt');

      const parsedState = await res.json();

      // Toon notificatie popup (zoals collection page)
      showAddedNotification(button);
      pulseAdded(button);

      // Track in session storage
      const addedSet = getAddedSet();
      addedSet.add(String(variantId));
      saveAddedSet(addedSet);

      // Re-enable button na korte delay
      setTimeout(() => {
        button.disabled = false;
      }, 500);

      await refreshCartUI();
      await showCartNotificationFromParsedState(parsedState);

      // extra zekerheid: meteen syncen met echte cart
      await syncAddedStateWithCart();
    } catch (err) {
      console.error(err);
      button.disabled = false;
      // Toon error notificatie in plaats van button text wijzigen
      showErrorNotification(button, 'Mislukt');
    }
  }

  // Error notificatie helper
  function showErrorNotification(button, message) {
    const cardWrapper = button.closest('.card-wrapper');
    if (!cardWrapper) return;

    const notification = document.createElement('div');
    notification.className = 'quick-add-notification quick-add-notification--error';
    notification.textContent = message;
    notification.style.cssText = `
      position: absolute;
      bottom: 5.5rem;
      right: 1.6rem;
      background: #d32f2f;
      color: white;
      padding: 6px 12px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 600;
      white-space: nowrap;
      z-index: 100;
      animation: fadeInOut 2s ease forwards;
      pointer-events: none;
    `;
    cardWrapper.appendChild(notification);
    setTimeout(() => notification.remove(), 2000);
  }

  /* Alles toevoegen */
  function setupAddAllToCartButton() {
    const btn = $(SELECTORS.addAllBtn);
    if (!btn) return;

    // voorkom dubbele binding
    if (btn.__boundWishlistAddAll) return;
    btn.__boundWishlistAddAll = true;

    btn.addEventListener('click', debounce(async () => {
      const handles = Array.from(new Set(getWishlist()));
      if (!handles.length) return;

      btn.disabled = true;
      const original = btn.textContent;
      btn.textContent = 'Toevoegen...';

      const failed = [];
      let lastParsedState = null;
      const addedSet = getAddedSet();
      const sections = getCartSections();

      for (const handle of handles) {
        try {
          const product = await fetchProduct(handle);
          const variantId = product?.variants?.[0]?.id;
          if (!variantId) throw new Error('Geen variant');

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: variantId, quantity: 1, sections, sections_url: window.location.pathname }),
          });
          if (!res.ok) throw new Error('Add failed');

          lastParsedState = await res.json();

          addedSet.add(String(variantId));
          const btnForVariant = document.querySelector(`.quick-add__submit[data-variant-id="${variantId}"]`);
          if (btnForVariant) { showAddedNotification(btnForVariant); pulseAdded(btnForVariant); }
        } catch (e) {
          console.warn(`[Wishlist] Fout bij toevoegen: ${handle}`, e);
          failed.push(handle);
        }
      }

      saveAddedSet(addedSet);

      setWishlist(failed);       // verwijder gelukt, laat mislukte staan
      await renderWishlist();

      await refreshCartUI();
      if (lastParsedState) await showCartNotificationFromParsedState(lastParsedState);

      // sync na bulk add
      await syncAddedStateWithCart();

      btn.textContent = failed.length ? `Mislukt bij ${failed.length}` : 'Alles toegevoegd!';
      btn.style.backgroundColor = failed.length ? '#d32f2f' : '#2e7d32';

      setTimeout(() => {
        btn.textContent = original;
        btn.style.backgroundColor = '';
        btn.disabled = false;
      }, 2200);
    }, 250));
  }

  /* ---------- ✅ Cart-state sync met echte cart ---------- */
  async function syncAddedStateWithCart() {
    // 1) Haal huidige cart-variant_ids op
    let cartVariantIds = new Set();
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (res.ok) {
        const cart = await res.json();
        cartVariantIds = new Set((cart.items || []).map(i => String(i.variant_id)));
      }
    } catch (e) {
      console.warn('[Wishlist] Cart sync mislukt', e);
    }

    // 2) Lees lokale "toegevoegd" set
    const addedSet = getAddedSet();

    // 3) Voor alle bekende knoppen: zet status o.b.v. cart
    $$(`.quick-add__submit[data-variant-id]`).forEach(btn => {
      const id = btn.getAttribute('data-variant-id');
      if (cartVariantIds.has(id)) {
        applyAddedState(btn);
        addedSet.add(id);
      } else {
        clearAddedState(btn);
        addedSet.delete(id);
      }
    });

    // 4) Sla lokaal op (voor consistentie)
    saveAddedSet(addedSet);
  }

  function setupCartStateSync() {
    // a) Eerste sync na render
    syncAddedStateWithCart();

    // b) Thema custom events
    document.addEventListener('cart:refresh', syncAddedStateWithCart);
    document.addEventListener('cart:change', syncAddedStateWithCart);
    document.documentElement.addEventListener?.('cart:refresh', syncAddedStateWithCart);

    // c) Online Store 2.0 pub/sub (indien beschikbaar)
    try {
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, syncAddedStateWithCart);
      }
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartError) {
        subscribe(PUB_SUB_EVENTS.cartError, syncAddedStateWithCart);
      }
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartOpen) {
        subscribe(PUB_SUB_EVENTS.cartOpen, syncAddedStateWithCart);
      }
    } catch (e) {}

    // d) Vangnet: observeer het cart-bubble element op DOM-wijzigingen
    const bubble = document.querySelector('#cart-icon-bubble');
    if (bubble && window.MutationObserver) {
      const mo = new MutationObserver(debounce(syncAddedStateWithCart, 200));
      mo.observe(bubble, { childList: true, subtree: true, attributes: true });
    }

    // e) Ook syncen bij terugnavigeren vanuit cache
    window.addEventListener('pageshow', () => syncAddedStateWithCart());
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    try {
      setupAddAllToCartButton();
      renderWishlist();
      updateWishlistCount();
      highlightWishlistIcons();

      // ✅ NIEUW: cart-status syncen
      setupCartStateSync();

      if (!document.__wishlistChangedBound) {
        document.addEventListener('wishlist:changed', async () => {
          await renderWishlist();
          updateWishlistCount();
          highlightWishlistIcons();
          // na her-render ook even syncen
          await syncAddedStateWithCart();
        });
        document.__wishlistChangedBound = true;
      }
    } catch (e) {
      console.error('[Wishlist] Init fout:', e);
    }
  });

  /* ---------- Aanvullende CSS tip (in je stylesheet) ----------
  .added-pulse { transform: scale(1.02); transition: transform .2s ease; }
  ------------------------------------------------------------- */
})();
